module.exports = __webpack_public_path__ + "static/xstyle-fff9c2122a199cfdda254a28d48d22d3.png";